import React from "react";

import Modal from "./Modal";
import ModalFooterCloseBtn from "./ModalFooterCloseBtn";
import QuickCapturePanel from "./QuickCapturePanel";

// Just the modal chrome now. The Pro gating, promo and demo moved to QuickCapturePanel so
// they aren't tied to being in a modal - In the Wild renders the same panel inline.
export default function QuickCaptureModal(props) {
  const { onHidden } = props;

  return (
    <Modal
      footer={<ModalFooterCloseBtn text="Close" />}
      id="quick-capture-modal"
      onHidden={onHidden}
      size="large"
      title="Quick Capture"
    >
      <QuickCapturePanel {...props} />
    </Modal>
  );
}
